module.exports = __webpack_public_path__ + "img/thumb-tofu-gehaktburgers.96eed735.jpeg";